import { ComponentProps } from 'react';
import { ButtonV2 } from '@bridebook/ui';
import mergeStyles from '@bridebook/ui/src/fela-utils/merge-styles';
import { IconPaperplane } from '@bridebook/ui/src/icons';

export interface ToggleEnquiryFormButtonCompProps extends ComponentProps<typeof ButtonV2> {
  noIcon?: boolean;
  fixedWidth?: number;
}

const ToggleEnquiryFormButton = ({
  children,
  noIcon = false,
  fixedWidth,
  styleWrapper = {},
  styleButton,
  startIcon,
  ...rest
}: ToggleEnquiryFormButtonCompProps) => (
  <ButtonV2
    data-name="supplier-profile-enquiry-toggle-button"
    dataTest="supplier-profile-enquiry-toggle-button"
    styleWrapper={mergeStyles([styleWrapper, fixedWidth ? { width: fixedWidth } : {}])}
    styleButton={mergeStyles([styleButton ? styleButton : {}])}
    startIcon={
      noIcon ? undefined : startIcon ? startIcon : <IconPaperplane color="white" width={15} />
    }
    {...rest}>
    {children}
  </ButtonV2>
);

export default ToggleEnquiryFormButton;
